import { render, staticRenderFns } from "./transitionPage.vue?vue&type=template&id=709448e2&scoped=true&"
import script from "./transitionPage.vue?vue&type=script&lang=js&"
export * from "./transitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709448e2",
  null
  
)

export default component.exports